import { Object3D } from 'three'
import * as _ from 'underscore'
import { LHFEventDispatcher } from '../../com/LHFEventDispatcher'
import { SpriteMarker } from '../marker/SpriteMarker'
import { MarkerRaycaster } from '../control/MarkerRaycaster'
import { TextureRes } from '../resources/TexturesRes'
import {getLangValue, globalEvent, PANO_CONFIG} from './PanoConfig'
import { getPanoPosition } from './utils'
import { PanoEvent } from '../events/PanoEvents'
import { LocationSprite } from '../marker/LocationSprite'
import {TimeLineMana} from "../TimeLineMana";

/** * 精灵图标记管理 */
class SpriteMarkerMana extends LHFEventDispatcher {
  constructor(scene_, camera_, dom_) {
    super()

    this.scene = scene_
    this.spriteHolder = new Object3D()
    this.scene.add(this.spriteHolder)
    this.camera_ = camera_
    this.dom_ = dom_
    this.markerRaycaster = new MarkerRaycaster(dom_, camera_)
    // 交互选中
    this.markerRaycaster.addEventListener(PanoEvent.MARKER_SELECT, event => {
      this.parseMarkerSel(event.data)
      //globalEvent.dispatchEvent(event);
    })
    this.sprites = []
    this.locations = []
    this.init()
  }

  /**
   * 解析选中数据
   * @param {object} data
   */
  parseMarkerSel(data) {
    // var that = this
    console.log('data:',data);
    globalEvent.dispatchEvent({type:PanoEvent.MARKER_SELECT,data:data});
    // switch (data.event) {
    //   // 切换场景
    //   case 'scene':
    //     this.dispatchEvent({
    //       type: PanoEvent.SCENE_CHANGE,
    //       data: data.target
    //     })
    //     break
    // }
  }

  init() {}
  /**
   * 设置当前场景
   * @param {object} sceneData
   */
  setCurPano(sceneData_) {
    this.sceneData = sceneData_
    // 清除标记
    this.clear()
    // 展示默认需要的标记
    let defaultShowMarkers = _.filter(
      this.sceneData.markers,
      item => item.defaultShow
    )
    defaultShowMarkers.forEach(element => {
      this.addMarker(element)
    });
    // 将标记添加到时间轴管理
    new TimeLineMana(PANO_CONFIG.VIDEO_DOM,this.sprites);
  }

  /**
   * 标记
   */
  clear() {
    // 清除标记交互
    this.markerRaycaster.clearMarkers()
    while (this.sprites.length) {
      let markerItem = this.sprites.pop()
      this.spriteHolder.remove(markerItem)
      markerItem.dispose()
    }
    this.sprites = []
    // 文字
    while (this.locations.length) {
      let location_ = this.locations.pop()
      this.spriteHolder.remove(location_)
      LocationSprite.recSprite(location_)
    }
    this.locations = []
  }

  /**
   * 添加一个标记
   */
  addMarker(markerData_) {
    let marker = new SpriteMarker()
    // 根据当前语言版本获取一个贴图id
    let tID = getLangValue(markerData_.texture_cn, markerData_.texture_en)
    let tMana = TextureRes.getInstace()
    // 根据贴图id获取贴图
    let tIni = _.find(tMana.textures, item => {
      return item.key === tID
    })
    // 更改标记的属性
    marker.changeAttr(
      tIni.fps,
      tIni.keynum,
      tIni.texture,
      markerData_.width,
      markerData_.height,
      markerData_.animation
    )
    // 添加到交互列表
    marker.userData = markerData_
    // 将二维位置转换为 球坐标
    let pos = getPanoPosition(
      markerData_.left,
      markerData_.top,
      this.sceneData.width,
      this.sceneData.height,
      markerData_.scale
    )
    // 设置位置
    marker.position.copy(pos)
    marker.panoID = markerData_.id;
    marker.visible=false;
    this.markerRaycaster.addMarkers([marker])
    //marker.position.copy(pos)
    // 添加显示
    this.spriteHolder.add(marker)
    //this.spriteHolder.add(marker)

    this.sprites.push(marker)
  }

  /**
   * 动画更新
   * @param {number} delta_
   */
  update(delta_) {
    for (let i = 0; i < this.sprites.length; i++) {
      const element = this.sprites[i]
      element.update(delta_)
    }
  }
}
export { SpriteMarkerMana }



// WEBPACK FOOTER //
// ./src/webgl/panorama/SpriteMarkerMana.js